import React from "react";
import { Link } from 'react-router-dom';
import CloseIcon from '../Images/EditDetails.svg'
const EditPopUp = () => {
    return (
        <>
            <div className="EditPopUp">
                <div className="row">
                    <div className="col-md-5 EditPopUpForm">

                        <form>
                            <div className="CloseForm">
                                <div>
                                    <h4 className="mb-4">Edit Details</h4>
                                </div>
                                <div>
                                    <img src={CloseIcon} />
                                </div>
                            </div>
                            <hr/>


                            <select id="" name="">
                                <option value="">Category of Industry</option>
                                <option value="">Canada</option>
                                <option value="">USA</option>
                            </select>


                            <select id="" name="">
                                <option value="">Type of Specialization</option>
                                <option value="">Canada</option>
                                <option value="">USA</option>
                            </select>

                            <select id="" name="">
                                <option value="">Cover Amount</option>
                                <option value="">Canada</option>
                                <option value="">USA</option>
                            </select>

                            <input type="text" id="lname" name="lastname" placeholder="Date of Birth" />

                            <input type="text" id="fname" name="firstname" placeholder="Mobile number" />
                            <Link to="/Quotation">
                                <input type="submit" value="View Quotes" />
                            </Link>

                            {/*<small>By clicking I agree to all <span className="green-text">T&C</span></small>*/}
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
}

export default EditPopUp;